"use client";
import { Box, GridItem, SimpleGrid } from "@chakra-ui/react";
import { Balancer } from "react-wrap-balancer";
import PageLayout from "@/layouts/pageLayout";
import { useHeadingVariant, useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text } from "@/elements";
import BgImage from "public/shared/lbBg.png";
import Certificates from "@/components/certificates";
import { WHY_ONEMIND_CONSTANTS } from "./constants";

const StandardsComp = () => {
  const { title, desc } = WHY_ONEMIND_CONSTANTS;
  const HeadingVariant = useHeadingVariant();
  const TextVariant = useTextVariant();

  return (
    <Box bgImage={`url(${BgImage.src})`} backgroundSize="cover " py={4} mt={14}>
      <PageLayout spacing={8}>
        <SimpleGrid columns={{ base: 1, sm: 2, md: 5 }} gap={{ base: 4, sm: 16 }}>
          <GridItem colSpan={{ base: 1, sm: 2, md: 2 }}>
            <Heading as="h1" variant={HeadingVariant}>
              {title}
            </Heading>
          </GridItem>
          <GridItem colSpan={{ base: 1, sm: 2, md: 3 }}>
            <Balancer>
              <Text variant={TextVariant} color="text.100">
                {desc}
              </Text>
            </Balancer>
          </GridItem>
        </SimpleGrid>
        <Box bgColor={"white"} w="fit-content" alignSelf={"center"} p={6} mb={6}>
          <Certificates showHeading={false} />
        </Box>
      </PageLayout>
    </Box>
  );
};

export default StandardsComp;
